const jsSHA = require('jssha')
const get = require('lodash/get')
const assign = require('lodash/assign')

module.exports = ['User', '$q', '$rootScope', 'DomUtils', '$utils', '$translate', function (User, $q, $rootScope, DomUtils, $utils, $translate) {
  const wechat = {
    wx: null,
    isReady: false,
    jsApiTicket: null
  }

  // 生成签名的随机串
  function numberToNonceString(number) {
    const legalChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    const twoDigitsNumber = number.toString(2)
    const result = []
    for (let i = 0; i < twoDigitsNumber.length; i = i + 6) {
      const num = parseInt(twoDigitsNumber.substring(i, 6), 2)
      result.push(legalChars[num])
    }

    return result.join('')
  }

  /**
   * 获取 jssdkFile
   * @param params
   * @returns jssdk variable `wx`
  */
  function getJsSdk () {
    console.log('---getJsSdk---', wechat.wx)
    if (wechat.wx) return $q.resolve(wechat.wx)

    const jssdkFileUrl = $rootScope.settings.wxwork.jssdkFileUrl
    return DomUtils.loadScript(jssdkFileUrl).then(_ => {
      wechat.wx = window.wx
      return wechat.wx
    })
  }

  /**
   * 获取 appId 和 jsapi_ticket
   * @param params
   * @returns {corpId, jsTicket, expiresIn}
  */
  function getJsApiTicket () {
    console.log('---getJsApiTicket---', wechat.jsApiTicket)
    if (wechat.jsApiTicket) return $q.resolve(wechat.jsApiTicket)

    return User.getCurrentUser().simpleCall({
      url: '/lunkr-plugins/weixin/getJsApiTicket',
      method: 'get'
    }).then(res => {
      wechat.jsApiTicket = res.var
      return res.var
    })
  }

  // 清理缓存数据
  wechat.clearCache = function() {
    console.log('---clearCache---')
    this.isReady = false
    this.jsApiTicket = null
  }

  /**
   * 注入配置信息
   * @param {Array} jsApiList 需要使用的JS接口列表
   * @returns {Promise}
  */
  wechat.config = function(jsApiList) {
    console.log('---config---', jsApiList)
    const that = this
    if (that.isReady) return $q.resolve('')

    return getJsSdk()
      .then(getJsApiTicket)
      .then(res => {
        console.log('getJsApiTicket', res)
        const corpId = res.corpId
        const jsTicket = res.jsTicket

        const defer = $q.defer()
        const timestamp = Math.floor(new Date().getTime() / 1000)
        const nonceStr = numberToNonceString(timestamp)
        const url = location.href.split('#')[0]

        const originalSignature = `jsapi_ticket=${jsTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
        console.log('originalSignature', originalSignature)
        const sha1 = new jsSHA('SHA-1', 'TEXT')  //eslint-disable-line
        sha1.update(originalSignature)
        const signature = sha1.getHash('HEX')

        const params = {
          debug: get($rootScope.settings, 'wxwork.debug', false), // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          beta: true, // 调用wx.invoke形式的接口值时，该值必须为true。
          appId: corpId,
          timestamp, // 必填，生成签名的时间戳
          nonceStr, // 必填，生成签名的随机串
          signature, // 必填，签名，见附录1
          jsApiList: jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2, 如 ['hideOptionMenu', 'previewFile']
        }
        console.log('config params', JSON.stringify(params))

        // https://developer.work.weixin.qq.com/document/path/90313
        window.wx.config(params)

        window.wx.ready(function () {
          console.log('--wx.config() ok--')
          that.isReady = true
          defer.resolve(true)
          /* config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
            config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
            对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。 */
        })

        window.wx.error(function (err) {
          console.log('--wx.config() error--', err)
          defer.reject(err)
          /* config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，
            也可以在返回的res参数中查看，对于SPA可以在这里更新签名。 */
        })

        setTimeout(_ => {
          console.log('--wx.config() timeout--')
          defer.reject({message: 'config callback timeout!'})
        }, 3000)

        return defer.promise
      })
  }

  /**
   * 将企业微信的回调API改成Promise，详见：https://developer.work.weixin.qq.com/document/path/90547
   * @param {Function} func 企业微信接口
   * @returns {Function} 支持Promise的接口函数，注意不能处理cancel和trigger。使用方法如: promisic(wx.checkJsApi)({jsApiList})
  */
  wechat.convertToPromise = function(func) {
    return function(params = {}) {
      return $q((resolve, reject) => {
        const args = assign(params, {
          success: res => resolve(res),
          fail: err => reject(err)
        })
        func(args)
      })
    }
  }

  /**
   * 企业微信文件/附件下载
   * @param {String} downloadURL 必须，文件下载地址
   * @param {Number} attsize 必须，文件大小（具有版本依赖CM-40308）
   * @param {String} filename 可选，文件名称
   * @returns
  */
  wechat.previewFile = function(downloadURL, attsize, filename) {
    if (!attsize) return $utils.$notify.set({message: $translate.instant('TIPS.WXWORK_UPGRADE_WMSVR')})

    const params = {
      url: downloadURL, // 需要预览文件的地址(必填，可以使用相对路径)
      name: filename, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
      size: attsize, // 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
    }
    if (window.wx && window.wx.previewFile) { // 移动端
      console.log('wx.previewFile', params)
      window.wx.previewFile({
        ...params,
        success: function (res) {
          console.log('previewFile接口调用成功', res)
        },
        fail: function (err) {
          console.error('previewFile接口调用失败', err)
        },
        complete: function (res) {
          console.log('previewFile接口调用完成', res)
        },
        cancel: function (res) {
          console.log('previewFile用户点击取消', res)
        }
      })
    } else { // PC端
      console.log('location to url: ' + downloadURL)
      window.location.href = downloadURL
    }
  }

  return wechat
}]



// WEBPACK FOOTER //
// ./src/js/services/wechatService.js